<div class="snack-bar-container" (click)='close()'>
  <div class="items"> {{message}} </div>
  <a class="mat-simple-snackbar-action" *ngIf="hasAction" (click)="action()">{{actionLabel}}</a>
</div>